<div class="flex row root" [class.compare-a]="compareRole === 'A'" [class.compare-b]="compareRole === 'B'">
    <div class="flex justify-center align-items-center index">{{ index + 1 }}</div>
    <div class="flex justify-center align-items-center remove">
        <button mat-icon-button (click)="removeHandler()" matTooltip="Remove">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
    <div class="flex justify-center align-items-center compare-toggle">
        @if (compareRole) {
            <button
                type="button"
                class="compare-badge"
                [class.compare-a-badge]="compareRole === 'A'"
                [class.compare-b-badge]="compareRole === 'B'"
                (click)="compareHandler($event)"
                matTooltip="Remove from compare"
                [attr.aria-label]="compareRole === 'A' ? 'Remove Compare A, primary' : 'Remove Compare B'"
            >{{ compareRole }}</button>
        } @else {
            <button
                mat-icon-button
                (click)="compareHandler($event)"
                matTooltip="Flag for compare"
            >
                <mat-icon>compare_arrows</mat-icon>
            </button>
        }
    </div>
    <div class="flex row mat-elevation-z5 main">
        @if (asset.is_ready === false) {
            @if ((failedAssetIds$ | async)?.has(asset.id)) {
                <div class="flex flex-20 justify-center align-items-center processing-thumbnail failed" matTooltip="Processing failed">
                    <mat-icon color="warn">error</mat-icon>
                </div>
                <div class="column flex-70 info">
                    <div class="title">{{ asset.name }}</div>
                    <div class="author">Processing failed</div>
                </div>
            } @else {
                <div class="flex flex-20 justify-center align-items-center processing-thumbnail">
                    <mat-spinner [diameter]="24"></mat-spinner>
                </div>
                <div class="column flex-70 info">
                    <div class="title">{{ asset.name }}</div>
                    <div class="author">{{ asset.author.name }} is uploading&hellip;</div>
                </div>
            }
        } @else {
            <img [src]="asset.thumbnail" class="flex flex-20" />
            <div class="column flex-70 info">
                <div class="title">{{ asset.name }}</div>
                <div class="author">{{ asset.author.name }}</div>
            </div>
        }
        <button mat-icon-button class="info-button remove" (click)="lockInfo()">
            <mat-icon>info</mat-icon>
        </button>
    </div>
</div>
